export default {
  "FACILITIES_APP_VIEW": "FACILITIES_APP_VIEW",
  "APP_COMMERCE_VIEW": "APP_COMMERCE_VIEW"
}